import React, { useEffect, useState } from "react";
import "./videoUploading.scss";
import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import videoUploading from "../../../../assets/images/upload/videoUploading.svg";
import cancelUpload from "../../../../assets/images/upload/cancelUploadIcon.svg";
import {
  fileUploadSuccessHandler,
  userInfoFetch,
} from "../../../../utlis/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import { isCancelError, uploadData } from "aws-amplify/storage";
import { setVideoFile } from "../../../../state/actions/videoUploadAction";
import { pageLocale } from "../../../../utlis/locale";

const VideoUploading = ({ statusVal, styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  // const romTabIndex = parseInt(sessionStorage.getItem("romTabIndex"));
  const file = useSelector((state) => state.videoSaved.pickedVideofile);
  const { video_uploading, alert, cancel_upload_btn } =
    pageLocale("videoUpload");
  const dispatch = useDispatch();
  const [uploadValue, setUploadValue] = useState(0);
  const [videoUpload, setVideoUpload] = useState(null);
  const urlPath = window.location.pathname;
  const date = new Date().getTime();
  const moduleFileName = () => {
    if (
      moduleInfo?.moduleId === 4 ||
      moduleInfo?.moduleId === 1 ||
      moduleInfo?.moduleId === 2
    ) {
      return date + "/" + "test_video.mp4";
    }
    if (moduleInfo?.moduleId === 5) {
      if (urlPath === "/rom-left-flexion") {
        return date + "/100/100.mp4";
      }
      if (urlPath === "/rom-left-extension") {
        return date + "/200/200.mp4";
      }
      if (urlPath === "/rom-right-flexion") {
        return date + "/300/300.mp4";
      }
      if (urlPath === "/rom-right-extension") {
        return date + "/400/400.mp4";
      }
    }
  };

  const modulePath = () => {
    if (moduleInfo?.moduleId === 4) {
      return `front_tug`;
    }
    if (moduleInfo?.moduleId === 1) {
      return `tug_side`;
    }
    if (moduleInfo?.moduleId === 2) {
      return `gait`;
    }
    if (moduleInfo?.moduleId === 5) {
      return `rom_knee`;
    }
  };

  const subModuleIdHandler = () => {
    if (moduleInfo?.moduleId === 5) {
      if (urlPath === "/rom-left-flexion") {
        return [100];
      }
      if (urlPath === "/rom-left-extension") {
        return [200];
      }
      if (urlPath === "/rom-right-flexion") {
        return [300];
      }
      if (urlPath === "/rom-right-extension") {
        return [400];
      }
    } else return null;
  };

  const acllfile = async () => {
    try {
      const videoUploadCall = uploadData({
        key: `${userInfoFetch()?.id}/${modulePath()}/` + moduleFileName(),
        data: file,
        options: {
          accessLevel: "guest",
          onProgress: ({ transferredBytes, totalBytes }) => {
            if (totalBytes) {
              setUploadValue(
                `${Math.round((transferredBytes / totalBytes) * 75)}`,
              );
            }
          },
        },
      });
      setVideoUpload(videoUploadCall);
      await videoUploadCall.result.then(() => {
        fileUploadSuccessHandler(
          userInfoFetch()?.id,
          moduleInfo?.moduleId,
          `${userInfoFetch()?.id}/${modulePath()}/` + date,
          subModuleIdHandler(),
        ).then((res) => {
          setUploadValue(100);
          dispatch(setVideoFile(null));
          sessionStorage.setItem("romReportId", res?.data?.data?.reportId);
          statusVal(3);
        });
      });
    } catch (error) {
      if (isCancelError(error)) {
        console.log("Error cancelling : ", error);
        // Handle error thrown by task cancellation
      } else {
        dispatch(setVideoFile(null));
        statusVal(4);
      }
    }
  };

  useEffect(() => {
    if (file) {
      acllfile();
    }
  }, []);

  const cancelUploadHandler = () => {
    if (videoUpload) {
      videoUpload.cancel();
      statusVal(2);
    }
  };

  return (
    <div className="video-uploading-main-wrapper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <Paper elevation={3} className={`info `}>
        <img src={videoUploading} alt="videoupload" className="uploding-img" />
        <Typography className="upload-text">{video_uploading}</Typography>
        <Box sx={{ width: "60%" }} className="bar-wrapper">
          <LinearProgress
            className="linear-bar"
            variant="determinate"
            value={uploadValue}
            sx={{
              "& .MuiLinearProgress-bar": {
                backgroundColor:
                  "linear-gradient(180deg, #F4C745 0%, #D19F0D 100%)",
              },
              backgroundColor:
                "linear-gradient(180deg, #F4C745 0%, #D19F0D 100%)",
            }}
          />
          <Typography className="upload-value">{uploadValue}%</Typography>
        </Box>
        <div className="cancel-btn-wrapper">
          <Typography className="cancel-info">{alert}</Typography>
          {uploadValue < 70 && (
            <div
              className="upload-cancel-btn-wrapper"
              onClick={() => cancelUploadHandler()}
            >
              <img src={cancelUpload} alt="cancel" />
              <Typography className="cancel-btn-text">
                {cancel_upload_btn}
              </Typography>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default VideoUploading;
